import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CategoryIcon from "@material-ui/icons/Category";
import { BiEdit } from "react-icons/bi";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { localApi } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);

export default function UpdateUnit(props) {
  const [items, setItems] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");

  const [title, setTitle] = React.useState("");
  const [subUnit, setSubUnit] = React.useState("");
  const [factor, setFactor] = React.useState("");

  const [titleErr, setTitleErr] = React.useState("");
  const [subUnitErr, setSubUnitErr] = React.useState("");
  const [factorErr, setFactorErr] = React.useState("");

  const [getId, setGetId] = React.useState("");

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getSets() {
    const api = localApi + `/unit/list/byAdminId/${userObj && userObj.id}`;
    const result = await fetch(api);
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult.metalData);
  }

  useEffect(() => {
    getSets();
  }, []);

  const handleSimple = (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.unitId == value);
    // console.log(item);
    setSimpleSelect(value);
    setTitle(item.title);
    setSubUnit(item.subunit);
    setFactor(item.con_factor);
    setGetId(item.unitId);
  };

  const SubmitUpdateUnit = async (e) => {
    let errorCount = 0;
    if (title === "" || !title) {
      errorCount++;
      setTitleErr("Title is Required");
    }

    if (subUnit === "" || !subUnit) {
      errorCount++;
      setSubUnitErr("SunUnit is Required");
    }

    if (factor === "" || !factor) {
      errorCount++;
      setFactorErr("Factor is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          title: title,
          subunit: subUnit,
          con_factor: factor,
        }),
      };

      fetch(localApi + `/unit/updateById/${getId}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          //   console.log(data);
          if (data.error == true) {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          } else {
            alertTypeOps("danger");
            alertMsgOps("Already Exits");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <BiEdit />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Update Unit</small>
              </h3>
            </CardHeader>

            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Updated Unit</SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Title...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Title...
                      </MenuItem>
                      {items &&
                        items.map((item) => (
                          <MenuItem
                            key={item.unitId}
                            value={item.unitId}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Title..."
                    id="title"
                    inputProps={{
                      placeholder: "Title ...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="title"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      setTitleErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{titleErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="SubUnit..."
                    id="subUnit"
                    inputProps={{
                      placeholder: "Sub Unit...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="subUnit"
                    value={subUnit}
                    onChange={(e) => {
                      setSubUnit(e.target.value);
                      setSubUnitErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{subUnitErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Con Factor..."
                    id="factor"
                    inputProps={{
                      placeholder: "Con Factor...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="factor"
                    value={factor}
                    onChange={(e) => {
                      setFactor(e.target.value);
                      setFactorErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{factorErr}</span>
                </GridItem>
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitUpdateUnit}
                className={classes.updateProfileButton}
              >
                Update
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Update</Button>
              ) : (
                <Button
                  color="rose"
                  onClick={SubmitUpdateUnit}
                  className={classes.updateProfileButton}
                >
                  Update
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
